import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Loader from '../../../shared/components/Loader/Loader';
import ResponsiveHeader from '../../../shared/components/ResponsiveHeader';
import { Container } from 'react-bootstrap';
import { getCookie } from '../../../utils/cookies';
import { useTranslation } from 'react-i18next';
import { INFLUENCERS_ENDPOINTS } from '../../../config/api';

function Payments() {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [iframe, setIframe] = useState('')
  const [height, setHeight] = useState('1000');

  const language = getCookie('i18next') || getCookie('locale') || 'en';

  useEffect(() => {
    axios.get(INFLUENCERS_ENDPOINTS.USERS.TIPALTI_IFRAME(language))
      .then(({ data }) => {
        if (data.iframe) {
          setIframe(data.iframe);
        }
      }).catch(err => console.error(err) );
  }, [language])

  const tipaltiHandler = (evt) => {
    if (evt.data && evt.data.TipaltiIframeInfo) {
      if (evt.data.TipaltiIframeInfo.height)
        setHeight(evt.data.TipaltiIframeInfo.height)
    }
  }

  if (window.addEventListener) {
    window.addEventListener("message", tipaltiHandler, false);
  }

  const onIframeLoad = () => setLoading(false);

  return (
    <Container className="mt-6">
      <ResponsiveHeader
        xs='h4'
        sm='h3'
        text="Payments"
        className='mb-5'
      />

      <p>{t('influencers.pages.profile.payments.description')}</p>

      {loading && <Loader loading={loading} />}

      <iframe
        src={iframe}
        onLoad={onIframeLoad}
        width='100%'
        height={height}
        className='mb-6'
        style={{ border: '0px' }}
      />
    </Container>
  );
}

export default Payments;
